/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_Delete_Confirm_AcceptInputs */

const en_company_jobs_delete_confirm_accept = /** @type {(inputs: Company_Jobs_Delete_Confirm_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const de_company_jobs_delete_confirm_accept = /** @type {(inputs: Company_Jobs_Delete_Confirm_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Company_Jobs_Delete_Confirm_AcceptInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_delete_confirm_accept = /** @type {((inputs?: Company_Jobs_Delete_Confirm_AcceptInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_Delete_Confirm_AcceptInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_delete_confirm_accept(inputs)
	return en_company_jobs_delete_confirm_accept(inputs)
});